<template>
    <el-card class="box-card" v-for="(plan_info, index) in plans" :key="plan_info.id">
        <div style="padding-left: 50px;">
            <div style="margin-top:30px;margin-bottom:30px;float: left;width: 37%;">
                <div class="group_plan_info_recruit_tag" style="text-align: left;">
                    <div style="text-align: left;cursor: pointer;font-weight: bold">
                        {{ province_score_gailv[plan_info.forecast_low_score] || '' }}%
                        {{ province_score_chongwenbao[plan_info.forecast_low_score] || '' }}
                        <span style="cursor: pointer;" @click="show_majors_job_fun(plan_info.majors_list)">{{ plan_info.zhuanye_mingcheng }} [{{ plan_info.type_str }}]</span>
                        <span style="color: #e8320a;font-size: 16px;" v-if="plan_info.new_major === 1">
                            新
                        </span>
                    </div>
                    <div
                        style="border: #898989 1px dashed;border-radius: 5px;margin-right: 20px;margin-bottom:10px;padding: 5px;"
                        v-if="plan_info.foreign_rules.length > 0 || plan_info.foreign_study_mode.length > 0 || plan_info.foreign_universities.length > 0">
                        <div>
                            <div v-if="plan_info.foreign_universities.length > 0"
                                 style="font-size:12px;margin-bottom: 5px;">合作院校:
                                {{ plan_info.foreign_universities }}
                            </div>
                            <div v-if="plan_info.foreign_study_mode.length > 0"
                                 style="font-size:12px;margin-bottom: 5px;color: #e8320a">就读模式:
                                {{ plan_info.foreign_study_mode }}
                            </div>
                            <div v-if="plan_info.foreign_rules.length > 0" style="font-size:14px;">
                                <a target="_blank" :href="plan_info.foreign_rules">查看招生简章</a>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 10px;">
                        <el-popover placement="top-start" :width="200" trigger="hover"
                                    :content="system_tips_list[2]['name']">
                            <template #reference>
                                <el-tag size="mini">{{ system_tips_list[2]['name'] }}:{{
                                        plan_info.use_sum
                                    }}
                                </el-tag>
                            </template>
                        </el-popover>
                        <el-popover placement="top-start" :width="200" trigger="hover"
                                    :content="system_tips_list[1]['name']">
                            <template #reference>
                                <el-tag size="mini">{{ system_tips_list[1]['name'] }}:
                                    <span style="font-weight: bold">{{ plan_info.forecast_low_score }}</span>
                                </el-tag>
                            </template>
                        </el-popover>
                    </div>
                </div>
                <div style="font-size: 10px;color: #a19f9f;margin: 5px auto 10px auto;"
                     v-html="plan_info.remarks"></div>
                <div class="group_plan_info_school_tag" v-if="user_power.show_major_label === 1">
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.discipline_ranking_major_str !== ''">
                        {{ plan_info.discipline_ranking_major_str }}
                    </el-tag>
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.postgraduate_major_str !== ''">
                        {{ plan_info.postgraduate_major_str }}
                    </el-tag>
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.doctor_major_str !== ''">{{
                            plan_info.doctor_major_str
                        }}
                    </el-tag>
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.first_class_major_str !== ''">{{
                            plan_info.first_class_major_str
                        }}
                    </el-tag>
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.nation_feature !== undefined && plan_info.nation_feature !== ''">
                        {{ plan_info.nation_feature }}
                    </el-tag>
                    <el-tag size="mini" type="danger" style="margin-right: 5px;"
                            v-if="plan_info.double_first_class_level !== undefined && plan_info.double_first_class_level !== ''">
                        {{ plan_info.double_first_class_level }}
                    </el-tag>
                </div>
            </div>
            <div class="group_plan_info_major_list" style="border-left: 1px #EBEBEB solid;">
                <div>
                    <div>招生计划</div>
                    <el-row>
                        <el-col :span="4">
                            <div class="group_plan_info_major_info_desc">
                                <span>人数</span>&nbsp;|&nbsp;<span>{{ plan_info.num }}</span>
                            </div>
                        </el-col>
                        <el-col :span="4" :offset="1">
                            <div class="group_plan_info_major_info_desc">
                                <span>学年</span>&nbsp;|&nbsp;<span>{{ plan_info.length }}</span>
                            </div>
                        </el-col>
                        <el-col :span="4" :offset="1">
                            <div class="group_plan_info_major_info_desc">
                                <span>学费</span>&nbsp;|&nbsp;
                                <span v-if="plan_info.fees >= 10000"
                                      style="color: red;">{{ plan_info.fees }}</span>
                                <span v-else>{{ plan_info.fees }}</span>
                            </div>
                        </el-col>

                    </el-row>
                </div>
                <div style="margin-top: 10px;">
                    <div>统计 ( 录取人数 / 线差 / 最低分 / 最低位次 )</div>
                    <div class="group_plan_info_major_info_desc"
                         style="height: 30px;line-height: 30px;padding-left: 20px;">
                        <div style="width: 33%;display: inline-block;text-align: left;"
                             v-for="(info, year) in plan_info.historical_data">
                            <div style="height: 30px;line-height: 30px;display: flex;justify-content:left;align-items: center;"
                                 v-if="info.number_basics !== ''">
                                ({{ year }})
                                {{ info.number_basics }}&nbsp;/&nbsp;
                                {{ info.line_diff_basics }}&nbsp;/&nbsp;
                                {{ info.low_score_basics }}&nbsp;
                                <el-tooltip
                                    v-if="info.low_score_from !== undefined && info.low_score_from !== null && info.low_score_from.length > 0"
                                    class="box-item"
                                    effect="dark"
                                    :content="info.low_score_from"
                                    placement="top"
                                >
                                    <el-icon size="14" color="#E93A29" style="cursor: pointer;"><Warning /></el-icon>&nbsp;
                                </el-tooltip>/&nbsp;
                                {{ info.precedence_basics }}
                            </div>
                            <div style="height: 30px;line-height: 30px;display: inline-block;" v-else>
                                ({{ year }}) 未招生
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="group_plan_info_content">
                <div style="text-align: center;">
                    <div :class="plan_prediction_direction(plan_info)">{{ plan_info.match_str }}</div>
                </div>
                <div style="float: right;margin-right: 10px;height:30px;line-height: 30px;" v-if="plan_info.collection > -1" class="group_plan_info_action">
                    <span v-if="plan_info.collection === 1 || (sub_collect_plan_index[plan_info.danlie_group_key] && sub_collect_plan_index[plan_info.danlie_group_key][plan_info.id])" class="group_plan_info_selected"
                          @click="un_favorite(index, plan_info, 1)">
                        取消
                    </span>
                    <span v-else>
                        <span class="group_plan_info_select" @click="favorite(index, plan_info, 1)">选择</span>
                    </span>
                    <span style="color: #E93A29;" v-if="sub_collect_plan_index[plan_info.danlie_group_key] && sub_collect_plan_index[plan_info.danlie_group_key][plan_info.id]">
                        {{sub_collect_plan_index[plan_info.danlie_group_key][plan_info.id]}}
                    </span>
                </div>
                <div v-if="favorite_value == 1"
                     style="float: right;height:30px;line-height: 30px;text-align: center;margin-right: 10px;">
                    <el-select v-model="plan_info.user_score_rank" filterable placeholder="修改顺序" @change="rank_change($event, plan_info)"
                               style="width: 120px;">
                        <el-option
                            v-for="item in sub_select_rank"
                            :key="item"
                            :label="item"
                            :value="item"
                        />
                    </el-select>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>

import axios from "axios";

export default {
    name: 'group_plan_info',
    props: {
        plans: Array,
        favorite_value: Number,
        sub_select_rank: Array,
        province_score_gailv: Array,
        province_score_chongwenbao: Array,
        system_tips_list: Object,
        sub_collect_plan_index: Object,
        user_power: Object,
        sub_rank_change: {type: Function, default: null},
        show_majors_job: {type: Function, default: null},
        un_favorite: {type: Function, default: null},
        favorite: {type: Function, default: null},
        no_match_major: {type: Function, default: null},
        school_info: {type: Function, default: null},
        school_map: {type: Function, default: null},
    },
    data() {
        return {}
    },
    mounted() {

    },
    created() {
        if (this.user_power === undefined || this.user_power.show_major_label === undefined) {
            this.user_power = {'show_major_label': 1, 'submit_report': 1}
        }

    },
    computed: {
        plan_prediction_direction() {
            return function (info) {
                if (info === '冲') {
                    return 'group_plan_major_sprint'
                } else if (info === '稳') {
                    return 'group_plan_major_stable'
                } else {
                    return 'group_plan_major_floors'
                }
            }
        }
    },
    watch: {
    
    },
    methods: {
        rank_change(e, info){
            this.$emit('sub_rank_change', {'info': info, 'type': 2})
        },
        show_majors_job_fun(e) {
            //console.log(e)
            this.$emit('show_majors_job', e)
        },
        un_favorite(index, plan_info, type = 1) {
            //console.log('un_favorite')
            this.plans[index]['collection'] = 0
            let param = {
                "plan_id": plan_info.id,
                "school_id": plan_info.school_id,
                "deal_school": 0,
                "danlie_group_key": plan_info.danlie_group_key,
                "key": plan_info.danlie_biaoshi,
                "danlie_biaoshi": plan_info.danlie_biaoshi,
                "major_group_code": plan_info.major_group_code,
                "forecast_low_score": plan_info.school_forecast_low_score,
                "type": 2
            }
            this.$emit('un_favorite', param)
        },
        favorite(index, plan_info, type = 1) {
            //console.log('favorite')
            this.plans[index]['collection'] = 1
            this.$emit('favorite', index, plan_info, type)
        },
        no_match_major(e) {
            //console.log(e)
            this.$emit('no_match_major', e)
        },
        school_info(e) {
            //console.log(e)
            this.$emit('school_info', e)
        },
        school_map(e) {
            //console.log(e)
            this.$emit('school_map', e)
        },
    }
}
</script>
<style scoped>
.box-card {
    border: 0;
    margin-top: 15px;
}

.box-card >>> .el-card__body {
    padding: 0;
}

.box-card >>> .el-card__header {
    padding: 0;
}

.group_plan_info_name {
    position: absolute;
    height: 60px;
    width: 40px;
    line-height: 60px;
    padding-right: 10px;
    text-align: right;
    border-radius: 5px;
    color: white
}

.group_plan_info_majors {
    float: left;
    margin-left: 65px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    padding-right: 10px;
}

.group_plan_info_action {
    margin: 10px auto;
    text-align: center;
}

.group_plan_info_selected {
    height: 30px;
    line-height: 30px;
    padding: 10px 20px;
    cursor: pointer;
    border: 1px solid #E93A29;
    background-color: white;
    color: #E93A29;
    border-radius: 5px;
}

.group_plan_info_select {
    height: 30px;
    line-height: 30px;
    padding: 10px 20px;
    cursor: pointer;
    border: 1px solid #E93A29;
    background-color: #E93A29;
    color: white;
    border-radius: 5px;
}

.group_plan_info_collection {
    height: 60px;
    width: 100%;
    background-color: #E93A29;
}

.group_plan_info_un_collection {
    height: 60px;
    width: 100%;
    background-color: #F2F2F2;
}

.group_plan_info_collection_major {
    font-size: 20px;
    margin-right: 10px;
    color: #F2F2F2;
}

.group_plan_info_un_collection_major {
    font-size: 20px;
    margin-right: 10px;
    color: #333333;
}

.group_plan_info_content {
    margin-top: 30px;
    margin-bottom: 15px;
    float: left;
    width: 8%;
}

.group_plan_info_school_tag >>> .el-tag--light {
    margin-left: 0;
    margin-right: 5px;
    margin-bottom: 5px;
}

.group_plan_info_recruit_tag >>> .el-tag--light {
    margin-left: 0;
    margin-right: 5px;
    margin-bottom: 5px;
}

.group_plan_info_major_list {
    float: left;
    margin-top: 30px;
    margin-bottom: 20px;
    padding-left: 20px;
    width: 53%;
    overflow-y: auto;
}

.group_plan_info_major_info_desc {
    background-color: #F8F8F8;
    border-radius: 5px;
    margin-top: 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
}

.group_plan_info_major_remarks {
    background-color: #F8F8F8;
    border-radius: 5px;
    margin-top: 10px;
    min-height: 30px;
    line-height: 30px;
    text-align: left;
    font-size: 12px;
}

.group_plan_info_major_sprint {
    background-color: #F3AB50;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    margin: 0 auto;
    border-radius: 50%;
}

.group_plan_info_major_floors {
    background-color: #24C599;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    margin: 0 auto;
    border-radius: 50%;
}

.group_plan_info_major_stable {
    background-color: #4D94F1;
    height: 40px;
    width: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    margin: 0 auto;
    border-radius: 50%;
}
</style>
